import React from "react";
import { Typography } from "antd";
import AppLayout from "../components/layout/AppLayout";
import CustomerTransactionForm from "../components/transactions/CustomerTransactionForm";

const { Title } = Typography;

export default function CreateTransactionRequestPage() {
    return (
        <AppLayout>
            <Title level={2}>New Request</Title>
            <CustomerTransactionForm />
        </AppLayout>
    );
}